var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative", height: "calc(100vh - 100px)" } },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "pa-3": "", "grid-list-lg": "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                row: "",
                "align-center": "",
                "justify-space-between": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { grow: "" } },
                [
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(_vm._s(_vm.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c("v-card", {
                        attrs: {
                          flat: "",
                          color: "secondary",
                          height: "1px",
                          width: "100%"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { shrink: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        bottom: "",
                        transition: "slide-x-transition",
                        "nudge-width": 250,
                        "close-on-content-click": false,
                        "content-class": "menu-content__block"
                      },
                      model: {
                        value: _vm.dtActionOpen,
                        callback: function($$v) {
                          _vm.dtActionOpen = $$v
                        },
                        expression: "dtActionOpen"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "activator" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                fab: "",
                                dark: "",
                                small: "",
                                color: _vm.dtActionOpen
                                  ? "secondary"
                                  : "primary"
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("more_horiz")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { staticClass: "actions-menu__list primary--text" },
                        [
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled: !_vm.$route.meta[
                                  "transfer_service_book"
                                ]
                              },
                              on: { click: _vm.handleTransferModal }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$route.meta[
                                          "transfer_service_book"
                                        ]
                                          ? "primary"
                                          : "greyLight"
                                      }
                                    },
                                    [_vm._v("reply")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled: !_vm.$route.meta[
                                      "transfer_service_book"
                                    ]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Transférer\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            staticClass: "actions-menu__divider",
                            attrs: { color: "fuchsia" }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "pa-0": "", "grid-list-xl": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "gmap-map",
                                {
                                  staticStyle: {
                                    height: "180px",
                                    width: "100%"
                                  },
                                  attrs: {
                                    center: _vm.mapPosition,
                                    zoom: 15,
                                    "map-type-id": "terrain"
                                  }
                                },
                                [
                                  _vm.mapPosition
                                    ? _c("gmap-marker", {
                                        attrs: { position: _vm.mapPosition }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("h3", { staticClass: "primary--text" }, [
                                _vm._v("Descriptif du bien")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "", "mb-2": "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "secondary",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Type: ")]),
                                _vm._v(_vm._s(_vm.type || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Étage: ")]),
                                _vm._v(_vm._s(_vm.floor || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Surface: ")]),
                                _vm._v(_vm._s(_vm.square_meter || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Adresse: ")]),
                                _vm._v(_vm._s(_vm.address || "-"))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("h3", { staticClass: "primary--text" }, [
                                _vm._v("Carnet d'entretien")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "", "mb-2": "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "secondary",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Durée: ")]),
                                _vm._v(_vm._s(_vm.duration || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Créé le: ")]),
                                _vm._v(_vm._s(_vm.createdAt || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Activé le: ")]),
                                _vm._v(_vm._s(_vm.activatedAt || "-"))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("b", [_vm._v("Expire le: ")]),
                                _vm._v(_vm._s(_vm.expireAt || "-"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtTransferServiceBookModalVisible
        ? _c(
            "base-modal-duplicate",
            {
              key: "123",
              ref: "transfer-servicebook-modal",
              attrs: {
                "show-create-another": false,
                loading: _vm.dtIsRecording,
                "action-position": "center",
                icon: "reply",
                "icon-type": "icon",
                "before-close": _vm.handleBeforeModalClose,
                "submit-btn-title": "Transférer",
                "hide-default-action": true,
                title: "Transférer le carnet d'entretien",
                "is-dark-title": "",
                "max-width": "50%"
              },
              on: {
                onRecord: _vm.handleTransferServiceBook,
                onClose: _vm.handleClose
              },
              model: {
                value: _vm.dtTransferServiceBookModalVisible,
                callback: function($$v) {
                  _vm.dtTransferServiceBookModalVisible = $$v
                },
                expression: "dtTransferServiceBookModalVisible"
              }
            },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "base-control-label-vertical",
                            { attrs: { required: "", label: "Client" } },
                            [
                              _c("base-multi-select", {
                                key: 3,
                                attrs: {
                                  rules: [
                                    function(v) {
                                      return !!v || "Client est requis"
                                    }
                                  ],
                                  options: _vm.coClients,
                                  "return-object": false,
                                  fetch: _vm.handleGetClients,
                                  multiple: false
                                },
                                model: {
                                  value: _vm.client,
                                  callback: function($$v) {
                                    _vm.client = $$v
                                  },
                                  expression: "client"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ee091df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee091df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/service-book/details/template.html
// module id = null
// module chunks = 